// import React from 'react';
// import { Modal } from 'components';
// import { IconDelete, IconInformation, IconBtnCopy } from '../../img';
// import ContentLoader from 'react-content-loader';
// import './Integration.scss';
// import ReactTooltip from 'react-tooltip';
// const moment = require('moment');

// const TableRow = props => {
//   return (
//     <ContentLoader
//       height={50}
//       width={1208}
//       speed={3}
//       primaryColor="#eceef4"
//       secondaryColor="#fff"
//       {...props}
//     >
//       <rect x="0" y="15" rx="4" ry="4" width="10" height="10"></rect>
//       <rect x="160" y="13" rx="6" ry="6" width="250" height="20"></rect>
//       <rect x="460" y="13" rx="6" ry="6" width="400" height="20"></rect>
//       <rect x="920" y="13" rx="6" ry="6" width="200" height="20"></rect>
//     </ContentLoader>
//   );
// };

// const Webhook = ({
//   openClose,
//   data,
//   isWhite,
//   closeModal,
//   webhooks,
//   createWebhook,
//   deleteWebhook,
//   loading,
//   validator,
//   handleStateChangeInt,
//   copyEndpoint,
//   handleIsActive
// }) => {

//   const fnRedirect = (url) => {
//     window.open(url, '_blank');
//   };

//   let arrField = [];
//   for (const i in data.tl) {
//     const element = data.tl[i];
//     arrField.push({ ky: i, tp: element });
//   }

//   return (
//     <div>
//       <Modal
//         id='NotificationModal'
//         className='appconnectmodal appgooglemodal modalappmailchip'
//         title=''
//         content={
//           <div className="modal-body">
//             <div className="modal-app-content">
//               <div className="modal-app-box">
//                 <div className="modal-app-top">
//                   <div className="modal-app-left cupoin">
//                     <div className="app-img-block" onClick={() => fnRedirect(data.stul)}>
//                       <img className="" src={data.img} alt="google" />
//                     </div>
//                     <div className="app-title-left">
//                       <h4>{data.dn}</h4>
//                     </div>
//                   </div>
//                   {
//                     isWhite === false &&
//                     <div className="app-img-right">
//                       <ul className="integra-add-list">
//                         {
//                           data.hpulpxl &&
//                           <li onClick={() => fnRedirect(data.hpulpxl)}>
//                             <div className="integra-list-icon">
//                               <svg xmlns="http://www.w3.org/2000/svg" width="20.892" height="13.797" viewBox="0 0 20.892 13.797">
//                                 <g id="Group_280" data-name="Group 280" transform="translate(-243.75 -351.749)">
//                                   <path id="Path_155" data-name="Path 155" d="M293.979,352.179l-.6-.165a.272.272,0,0,0-.227.024.314.314,0,0,0-.15.189l-3.612,12.5a.292.292,0,0,0,.024.237.312.312,0,0,0,.189.15l.6.165a.267.267,0,0,0,.227-.024.314.314,0,0,0,.15-.189l3.611-12.5a.29.29,0,0,0-.024-.237.315.315,0,0,0-.189-.15Zm0,0" transform="translate(-37.595 0)" fill="#B0BEC5" stroke="#B0BEC5" stroke-width="1" />
//                                   <path id="Path_156" data-name="Path 156" d="M251.635,365.027a.306.306,0,0,0-.1-.223l-.484-.484a.3.3,0,0,0-.446,0l-4.512,4.512a.3.3,0,0,0,0,.446l4.512,4.512a.3.3,0,0,0,.446,0l.484-.483a.3.3,0,0,0,0-.446l-3.8-3.806,3.8-3.8a.3.3,0,0,0,.1-.223Zm0,0" transform="translate(-2 -10.407)" fill="#B0BEC5" stroke="#B0BEC5" stroke-width="1" />
//                                   <path id="Path_157" data-name="Path 157" d="M332.882,368.832l-4.512-4.512a.3.3,0,0,0-.445,0l-.484.484a.3.3,0,0,0,0,.446l3.8,3.8-3.8,3.806a.3.3,0,0,0,0,.446l.484.483a.3.3,0,0,0,.445,0l4.512-4.512a.306.306,0,0,0,0-.446Zm0,0" transform="translate(-68.586 -10.407)" fill="#B0BEC5" stroke="#B0BEC5" stroke-width="1" />
//                                 </g>
//                               </svg>
//                             </div>
//                             <span data-tip data-for='dntp' > Display notification on this platform</span>
//                             <div className="tootltip seeting-tooltip modal-tooltip" onClick={() => fnRedirect(process.env.REACT_APP_FROG_DOC_URL + data.furl)}>
//                               <ReactTooltip id='dntp' aria-haspopup='true' role='example'>
//                                 <p>Click here to know about how to install pixel on this platform</p>
//                               </ReactTooltip>
//                             </div>
//                           </li>
//                         }
//                         {
//                           (data.typ.indexOf('signup') !== -1 ||
//                             data.typ.indexOf('signup_recent') !== -1 ||
//                             data.typ.indexOf('signup_bulk') !== -1) &&
//                           <li onClick={() => fnRedirect(data.hpul)}>
//                             <div className="integra-list-icon">
//                               <svg xmlns="http://www.w3.org/2000/svg" width="20.328" height="11.053" viewBox="0 0 20.328 11.053">
//                                 <g id="mail_4_" data-name="mail (4)" transform="translate(-111 -136.965)">
//                                   <path fill="#B0BEC5" id="Path_684" data-name="Path 684" d="M167.4,137.7a.759.759,0,0,0-.53-.7c-.156-.049-5.4-.035-5.4-.035h-8.089l-.23,6.261.1,4.79h13.383a.76.76,0,0,0,.76-.76C167.4,138,167.4,137.763,167.4,137.7Zm-2.94.784L160,142.032l-4.568-3.545Zm-11.211,9.167.135-4.655.456-6.032h5.738s-6.365,0-6.424,0a.76.76,0,0,0-.7.692c0,.056,0-.269,0,4.172H149.76a.76.76,0,1,0,0,1.521h2.687v3.9a.76.76,0,0,0,.76.76h6.372Zm.718-1.157V139.28l5.566,4.32a.76.76,0,0,0,.939-.005l5.408-4.293v7.2Z" transform="translate(-36.074)" />
//                                   <path fill="#B0BEC5" id="Path_685" data-name="Path 685" d="M113.76,170.522h1.217a.76.76,0,1,0,0-1.521H113.76a.76.76,0,1,0,0,1.521Z" transform="translate(-1.899 -29.804)" />
//                                   <path fill="#B0BEC5" id="Path_686" data-name="Path 686" d="M84.194,297H81.76a.76.76,0,1,0,0,1.521h2.433a.76.76,0,1,0,0-1.521Z" transform="translate(30 -152.431)" />
//                                 </g>
//                               </svg>
//                             </div>
//                             <span data-tip data-for='gcd' > Get conversion data</span>
//                             <div className="tootltip seeting-tooltip modal-tooltip" onClick={() => fnRedirect(process.env.REACT_APP_FROG_DOC_URL + data.furl)}>
//                               <ReactTooltip id='gcd' aria-haspopup='true' role='example'>
//                                 <p>Click here to know about how to integrate with this platform</p>
//                               </ReactTooltip>
//                             </div>
//                           </li>
//                         }
//                         {
//                           (data.typ.indexOf('purchase') !== -1 ||
//                             data.typ.indexOf('purchase_bulk') !== -1 ||
//                             data.typ.indexOf('purchase_recent') !== -1) &&
//                           <li onClick={() => fnRedirect(data.hpul)}>
//                             <div className="integra-list-icon">
//                               <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
//                                 <path d="M20.12 6.71L17.29 3.88C16.7279 3.31723 15.9654 3.0007 15.17 3H8.83C8.03462 3.0007 7.27207 3.31723 6.71 3.88L3.88 6.71C3.31723 7.27207 3.0007 8.03462 3 8.83V18C3 18.7956 3.31607 19.5587 3.87868 20.1213C4.44129 20.6839 5.20435 21 6 21H18C18.7956 21 19.5587 20.6839 20.1213 20.1213C20.6839 19.5587 21 18.7956 21 18V8.83C20.9993 8.03462 20.6828 7.27207 20.12 6.71ZM8.12 5.29C8.31163 5.10727 8.56523 5.00368 8.83 5H15.17C15.4348 5.00368 15.6884 5.10727 15.88 5.29L17.59 7H6.41L8.12 5.29ZM18 19H6C5.73478 19 5.48043 18.8946 5.29289 18.7071C5.10536 18.5196 5 18.2652 5 18V9H19V18C19 18.2652 18.8946 18.5196 18.7071 18.7071C18.5196 18.8946 18.2652 19 18 19Z" fill="#B0BEC5"></path>
//                                 <path d="M15 11C14.7348 11 14.4804 11.1054 14.2929 11.2929C14.1054 11.4804 14 11.7348 14 12C14 12.5304 13.7893 13.0391 13.4142 13.4142C13.0391 13.7893 12.5304 14 12 14C11.4696 14 10.9609 13.7893 10.5858 13.4142C10.2107 13.0391 10 12.5304 10 12C10 11.7348 9.89464 11.4804 9.70711 11.2929C9.51957 11.1054 9.26522 11 9 11C8.73478 11 8.48043 11.1054 8.29289 11.2929C8.10536 11.4804 8 11.7348 8 12C8 13.0609 8.42143 14.0783 9.17157 14.8284C9.92172 15.5786 10.9391 16 12 16C13.0609 16 14.0783 15.5786 14.8284 14.8284C15.5786 14.0783 16 13.0609 16 12C16 11.7348 15.8946 11.4804 15.7071 11.2929C15.5196 11.1054 15.2652 11 15 11Z" fill="#B0BEC5"></path>
//                               </svg>
//                             </div>
//                             <span data-tip data-for='gpd'>  Get purchase data</span>
//                             <div className="tootltip seeting-tooltip modal-tooltip" onClick={() => fnRedirect(process.env.REACT_APP_FROG_DOC_URL + data.furl)}>
//                               <ReactTooltip id='gpd' aria-haspopup='true' role='example'>
//                                 <p>Click here to know about how to integrate with this platform</p>
//                               </ReactTooltip>
//                             </div>
//                           </li>
//                         }
//                         {
//                           (data.typ.indexOf('review') !== -1 ||
//                             data.typ.indexOf('review_feed') !== -1 ||
//                             data.typ.indexOf('review_bulk') !== -1 ||
//                             data.typ.indexOf('followers') !== -1 ||
//                             data.typ.indexOf('review_recent') !== -1) &&
//                           <li onClick={() => fnRedirect(data.hpul)}>
//                             <div className="integra-list-icon">
//                               <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
//                                 <path d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z" fill="#B0BEC5"></path>
//                                 <path d="M16 13C16.5523 13 17 12.5523 17 12C17 11.4477 16.5523 11 16 11C15.4477 11 15 11.4477 15 12C15 12.5523 15.4477 13 16 13Z" fill="#B0BEC5"></path>
//                                 <path d="M8 13C8.55228 13 9 12.5523 9 12C9 11.4477 8.55228 11 8 11C7.44772 11 7 11.4477 7 12C7 12.5523 7.44772 13 8 13Z" fill="#B0BEC5"></path>
//                                 <path d="M19.0706 4.93051C17.4298 3.27901 15.2642 2.25172 12.9472 2.02575C10.6302 1.79978 8.30696 2.38929 6.37799 3.69264C4.44903 4.996 3.03524 6.93152 2.38037 9.16552C1.7255 11.3995 1.87058 13.792 2.79061 15.9305C2.8865 16.1293 2.91796 16.353 2.88061 16.5705L2.00061 20.8005C1.9667 20.9627 1.97363 21.1307 2.02075 21.2896C2.06788 21.4484 2.15374 21.5931 2.27061 21.7105C2.36641 21.8056 2.48048 21.8803 2.60594 21.9302C2.7314 21.98 2.86565 22.004 3.00061 22.0005H3.20061L7.48061 21.1405C7.69814 21.1144 7.91873 21.1454 8.12061 21.2305C10.2591 22.1505 12.6516 22.2956 14.8856 21.6407C17.1196 20.9859 19.0551 19.5721 20.3585 17.6431C21.6618 15.7142 22.2513 13.3909 22.0254 11.0739C21.7994 8.75687 20.7721 6.5913 19.1206 4.95051L19.0706 4.93051ZM19.9006 13.2905C19.7051 14.4845 19.2413 15.6186 18.5442 16.6074C17.847 17.5963 16.9347 18.4141 15.8758 18.9994C14.8169 19.5847 13.639 19.9221 12.4308 19.9864C11.2227 20.0507 10.0156 19.8401 8.90061 19.3705C8.50515 19.2023 8.08034 19.1139 7.65061 19.1105C7.46289 19.1118 7.27559 19.1285 7.09061 19.1605L4.27061 19.7305L4.84061 16.9105C4.95413 16.2998 4.88095 15.669 4.63061 15.1005C4.161 13.9855 3.95041 12.7785 4.0147 11.5703C4.07899 10.3621 4.41647 9.18426 5.00175 8.12536C5.58703 7.06646 6.40486 6.15411 7.3937 5.45696C8.38254 4.75981 9.51663 4.29603 10.7106 4.10051C11.9639 3.89483 13.2481 3.99048 14.4571 4.37957C15.6661 4.76866 16.765 5.43999 17.6631 6.33805C18.5611 7.2361 19.2325 8.33506 19.6215 9.54403C20.0106 10.753 20.1063 12.0372 19.9006 13.2905Z" fill="#B0BEC5"></path>
//                               </svg>
//                             </div>
//                             <span data-tip data-for='grd'>Get review data</span>
//                             <div className="tootltip seeting-tooltip modal-tooltip" onClick={() => fnRedirect(process.env.REACT_APP_FROG_DOC_URL + data.furl)}>
//                               <ReactTooltip id='grd' aria-haspopup='true' role='example'>
//                                 <p>Click here to know about how to integrate with this platform</p>
//                               </ReactTooltip>
//                             </div>
//                           </li>
//                         }
//                         {
//                           (data.typ.indexOf('video_subscriber') !== -1 ||
//                             data.typ.indexOf('channel_subscriber') !== -1) &&
//                           <li onClick={() => fnRedirect(data.hpul)}>
//                             <div className="integra-list-icon">
//                               <svg xmlns="http://www.w3.org/2000/svg" width="27.458" height="20.797" viewBox="0 0 27.458 20.797">
//                                 <g id="youtube_1_" data-name="youtube (1)" transform="translate(0.001)">
//                                   <path id="Path_682" data-name="Path 682" d="M198.661,109.981l-6.066-3.319a1.114,1.114,0,0,0-1.649.977v6.581a1.112,1.112,0,0,0,1.642.981l6.066-3.262a1.114,1.114,0,0,0,.007-1.959Zm-6.106,3.412v-4.919l4.534,2.481Zm0,0" transform="translate(-180.707 -100.811)" fill="#b0bec5" />
//                                   <path id="Path_683" data-name="Path 683" d="M27.255,4.908V4.9a6.279,6.279,0,0,0-1.21-3.187A4.468,4.468,0,0,0,23.084.322L22.948.305,22.9.3C19.27.036,13.788,0,13.733,0h-.01c-.055,0-5.537.036-9.2.3L4.475.305,4.347.321A4.355,4.355,0,0,0,1.4,1.751,6.581,6.581,0,0,0,.2,4.88l0,.028C.193,5,0,7.19,0,9.388v2.055c0,2.2.194,4.387.2,4.479v.014a6.218,6.218,0,0,0,1.206,3.148,4.559,4.559,0,0,0,3.058,1.368c.112.013.208.024.273.035l.063.009c2.1.2,8.667.3,8.946.3h.017c.055,0,5.537-.036,9.167-.3l.048-.005.154-.017a4.255,4.255,0,0,0,2.917-1.4,6.58,6.58,0,0,0,1.2-3.129l0-.028c.008-.092.2-2.281.2-4.479V9.388c0-2.2-.194-4.387-.2-4.479Zm-1.407,6.534c0,2.034-.178,4.129-.194,4.322a5.108,5.108,0,0,1-.789,2.229,2.646,2.646,0,0,1-1.9.881l-.171.019c-3.511.254-8.786.293-9.029.294-.273,0-6.748-.1-8.78-.292-.1-.017-.217-.03-.335-.043a3.009,3.009,0,0,1-2.058-.86l-.015-.016A4.635,4.635,0,0,1,1.8,15.77c-.013-.145-.2-2.265-.2-4.328V9.388c0-2.032.177-4.125.194-4.321a5,5,0,0,1,.789-2.23,2.776,2.776,0,0,1,1.939-.918L4.662,1.9c3.562-.255,8.875-.293,9.066-.295s5.5.039,9.032.295l.142.017a2.881,2.881,0,0,1,1.971.893l.006.007a4.71,4.71,0,0,1,.774,2.239c.012.137.2,2.262.2,4.329Zm0,0" fill="#b0bec5" />
//                                 </g>
//                               </svg>
//                             </div>
//                             <span data-tip data-for='gysvs'> Get YouTube Subscribers or video stats</span>
//                             <div className="tootltip seeting-tooltip modal-tooltip" onClick={() => fnRedirect(process.env.REACT_APP_FROG_DOC_URL + data.furl)}>
//                               <ReactTooltip id='gysvs' aria-haspopup='true' role='example'>
//                                 <p>Click here to know about how to integrate with this platform</p>
//                               </ReactTooltip>
//                             </div>
//                           </li>
//                         }
//                       </ul>
//                     </div>
//                   }
//                 </div>
//               </div>
//               <div className="app-connect app-connect-google">
//                 {arrField && arrField.length > 0 && arrField.map((x, i) => {
//                   if (x.ky == 'rmk') {
//                     return <div className="nf-group-input mt-25" key={i}>
//                       <label>Name your connection</label>
//                       <div className="tootltip seeting-tooltip">
//                         <img data-tip data-for='rmk' src={IconInformation} alt="" />
//                         <ReactTooltip id='rmk' aria-haspopup='true' role='example'>
//                           <p>{data.tl.rmk}</p>
//                         </ReactTooltip>
//                       </div>
//                       <input type="text" name="rmk" className="nf-input" id="" placeholder="Name your connection"
//                         value={data.rmk}
//                         onChange={handleStateChangeInt} />
//                       {validator.message('Name your connection', data.rmk, 'required|required')}
//                     </div>;
//                   }
//                   else {
//                     return <div className="nf-group-input mt-25" key={i}>
//                       <label style={{ textTransform: 'capitalize' }}>{x.tp.replace('Enter', '')}</label>
//                       <div className="tootltip seeting-tooltip">
//                         <img data-tip data-for={x.ky} src={IconInformation} alt="" />
//                         <ReactTooltip id={x.ky} aria-haspopup='true' role='example'>
//                           <p>{x.tp}</p>
//                         </ReactTooltip>
//                       </div>
//                       <input type="text" name={x.ky} className="nf-input" id="" placeholder={x.tp}
//                         value={data[x.ky]}
//                         onChange={handleStateChangeInt} />
//                       {validator.message(x.tp, data[x.ky], 'required|required')}
//                     </div>;
//                   }
//                 })}
//                 <div className="nf-btn-login mt-10">
//                   <button type='button' className="nf-btn  nf-btn-default" onClick={(e) => createWebhook(e)}>
//                     Create
//                   </button>
//                 </div>
//               </div>
//               <div className="modal-subblock-title">
//                 <h4 className="mb-2 mt-40">Account Details</h4>
//               </div>
//               <form className="table-responsive">
//                 <table className="table tbl-middle-text tbl-header-bg tbl-th-bordernone tbl-app-list">
//                   <thead className="">
//                     <tr>
//                       <th>#</th>
//                       <th>Name</th>
//                       <th>Endpoint</th>
//                       <th>Created Date</th>
//                       <th>Active</th>
//                       <th>Action</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {loading == true ?
//                       <tr>
//                         <td colSpan="6">
//                           {Array(1)
//                             .fill('')
//                             .map((e, i) => (
//                               <TableRow key={i} style={{ opacity: Number(2 / i).toFixed(1) }} />
//                             ))}
//                         </td>
//                       </tr> : webhooks && webhooks.length > 0 ?
//                         webhooks.map((webInt, i) => {
//                           if (webInt._id == data.idForUsInt) webInt.ia = data.isIntActive ? data.isIntActive : false;
//                           let wbURL = webInt.d && webInt.d.webhookURL;
//                           return <tr key={i} style={{ width: '100%' }} className="tbody-td">
//                             <td>{i + 1}</td>
//                             <td>{webInt.rmk}</td>
//                             <td className="tbl-tdwidth-30X tbl-apicopy-col tbl-hightlight">
//                               {wbURL ? wbURL.slice(0, 30) + '...' : '-'}
//                             </td>
//                             <td>{moment(new Date(webInt.cdt)).format('MMM-DD-YYYY hh:mm:ss a')}</td>
//                             <td>
//                               <label className="switch-update mb-1">
//                                 <input type="checkbox" checked={webInt.ia} onChange={(e) => handleIsActive(webInt._id, e.target.checked)} />
//                                 <span className="slider round">
//                                   <samp className="slider-cricle">
//                                     <svg className="checkbox-insign checkbox-true" xmlns="http://www.w3.org/2000/svg" width="8" height="6" viewBox="0 0 20.028 14.958">
//                                       <path id="checkbox-true" d="M292.95,374.934l-11.8,11.8a.264.264,0,0,1-.376,0l-6.7-6.7a.263.263,0,0,1,0-.375l1.628-1.628a.264.264,0,0,1,.376,0l4.883,4.883,9.982-9.983a.264.264,0,0,1,.376,0l1.627,1.628a.265.265,0,0,1,0,.376Zm0,0" transform="translate(-273.5 -372.352)" fill="#fff" stroke="#fff" strokeWidth="1" />
//                                     </svg>
//                                     <svg className="checkbox-insign checkbox-false" xmlns="http://www.w3.org/2000/svg" width="7" height="7" viewBox="0 0 18.689 18.69">
//                                       <path id="checkbox-false" d="M279.237,367.344l6.338-6.338a.389.389,0,0,0,0-.551l-2.342-2.342a.389.389,0,0,0-.551,0l-6.338,6.338-6.338-6.338a.4.4,0,0,0-.551,0l-2.342,2.342a.389.389,0,0,0,0,.551l6.338,6.338-6.338,6.338a.389.389,0,0,0,0,.551l2.342,2.342a.389.389,0,0,0,.551,0l6.338-6.338,6.338,6.338a.387.387,0,0,0,.551,0l2.342-2.341a.39.39,0,0,0,0-.552Zm0,0" transform="translate(-267 -358)" fill="#fff" />
//                                     </svg>
//                                   </samp>
//                                 </span>
//                               </label>
//                             </td>
//                             <td>
//                               <span className="btn-action nf-btn btn-end-cpy light-bg-icon btn-icon-30  tbl-action-dlt"
//                                 onClick={() => copyEndpoint(wbURL)}                              >
//                                 <img data-tip data-for='cpwb' className="" src={IconBtnCopy} alt="google" />
//                                 <ReactTooltip id='cpwb' aria-haspopup='true' role='example'>
//                                   <p>Click to copy webhook URL</p>
//                                 </ReactTooltip>
//                               </span>
//                               <span data-tip data-for={`${'webhdlt' + webInt._id}`} className="btn-action nf-btn  btn-delete-light  light-bg-icon btn-icon-30  tbl-action-dlt" onClick={() => deleteWebhook({ id: webInt._id, inm: webInt.inm })}>
//                                 <img className="" src={IconDelete} alt="google" />
//                                 <ReactTooltip id={`${'webhdlt' + webInt._id}`} aria-haspopup='true' role='example'>
//                                   <p>Delete</p>
//                                 </ReactTooltip>
//                               </span>
//                             </td>
//                           </tr>;
//                         }) :
//                         <tr>
//                           <td colSpan='6' className="center-align">No record found</td>
//                         </tr>
//                     }
//                   </tbody>
//                 </table>
//               </form>
//             </div>
//           </div>
//         }
//         openCloseModal={() => closeModal()}
//         style={
//           {
//             modalStyle: {
//               display: openClose ? 'block' : 'none',
//               opacity: openClose ? 1 : 0
//             },
//             alignModalStyle: {
//               top: '50px'
//             }
//           }
//         }
//       />
//     </div>
//   );
// };

// export default Webhook;

import React from 'react';
import './Integration.scss';
import ContentLoader from 'react-content-loader';
import IntHeader from './IntHeader';

const getDemoCsv = () => {
  let CSV = 'https://storage.googleapis.com/wiser_goal/integration/Import_review_demo_CSV.csv';
  window.location.href = CSV;
};

const Webhook = ({
  data,
  webhookList,
  createWebhook,
  openReviewModel,
  deleteWebhook,
  loading,
  validator,
  handleStateChangeInt,
  hideShowDataSource,
  copyEndpoint,
}) => {
  webhookList = webhookList && webhookList.length > 0 && webhookList.filter(x => x.inm == data.in);
  let arrField = [];
  for (const i in data.tl) {
    const element = data.tl[i];
    arrField.push({ ky: i, tp: element });
  }
  let optField = [];
  for (const i in data.othrtl) {
    const element = data.othrtl[i];
    optField.push({ ky: i, tp: element });
  }
  console.log(optField, '===optField');
  return (
    <div>
      <div className="title-dataset-select">
        <IntHeader
          data={data}
          hideShowDataSource={hideShowDataSource}
          getDemoCsv={getDemoCsv}
        />
        <div className="wdgt-group-block wdgt-dataset-form  wdgt-group-ggplace">
          {arrField && arrField.length > 0 && arrField.map((x, i) => {
            if (x.ky == 'rmk') {
              return <div className="wdgt-group-input mt-15" key={i}>
                <label>Name your connection</label>
                <input
                  className="nf-input nf-input-sm"
                  name="rmk"
                  value={data.rmk}
                  placeholder="Name your connection"
                  onChange={handleStateChangeInt}
                />
                {validator.message('Connection name', data.rmk, 'required|required')}
              </div>;
            } else {
              return <div className="wdgt-group-input mt-15" key={i}>
                <label>{x.tp.replace('Enter', '')}</label>
                <input
                  className="nf-input nf-input-sm"
                  name={x.ky}
                  value={data[x.ky]}
                  placeholder={x.tp}
                  onChange={handleStateChangeInt}
                />
                {validator.message('Connection name', data[x.ky], 'required|required')}
              </div>;
            }
          })}
          {optField && optField.length > 0 && optField.map((x, i) => {
            return <div className="wdgt-group-input mt-15" key={i}>
              <label>{x.tp.replace('Enter', '')}</label>
              <input
                className="nf-input nf-input-sm"
                name={x.ky}
                value={data[x.ky]}
                placeholder={x.tp}
                onChange={handleStateChangeInt}
              />
            </div>;
          })}
          <div className="add-integra-btn text-center" onClick={() => createWebhook()}>
            <a className="nf-btn nf-btn-default">Create Connection</a>
          </div>
        </div>
        {loading === true ?
          <ContentLoader
            height={750}
            width={1750}
            speed={2}
            primaryColor="#fff"
            secondaryColor="#eceef4"
          >
            <rect x="150" y="40" rx="0" ry="0" width="1500" height="700"></rect>
          </ContentLoader>
          :
          <div className='sublistapp-connect-block'>
            <h5 className='title-connection'>Connection list</h5>
            <div className='app-list-sublistapp'>
              <div className='integra-data-headerblock'>
                <label className=''>Name</label>
                <label className=''>Action</label>
              </div>
              <div className='review-collection-scroll' style={{ height: 'calc(100vh - 350px)' }}>
                {webhookList && webhookList.length > 0 ?
                  webhookList.map((usInt, key) => {
                    if (usInt._id == data.usIntId) usInt.ia = data.intISActive ? data.intISActive : false;
                    let wbURL = usInt.d && usInt.d.web_url;
                    // (new RegExp(data.searchByName, 'i').test(usInt.rmk) == true &&
                    return <div className="card-editor card-intigra-block card-intigra-ggpalceislist" key={key}>
                      <div className="integra-checklist-item" >
                        <span className="">{usInt.rmk}</span>
                        <div className='collection-group-action  d-flex align-items-center'>
                          {/* <span className="btn-action nf-btn light-bg-icon btn-icon-20  tbl-action-dlt"
                            onClick={() => copyEndpoint(wbURL)}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="12.414" height="7.4" viewBox="0 0 12.414 7.4">
                              <path id="Path_14253" data-name="Path 14253" d="M6.207,98.725A7.744,7.744,0,0,0,.1,102.13a.491.491,0,0,0,0,.587,7.74,7.74,0,0,0,6.11,3.408,7.744,7.744,0,0,0,6.11-3.405.491.491,0,0,0,0-.587A7.74,7.74,0,0,0,6.207,98.725Zm.17,6.305A2.611,2.611,0,1,1,8.812,102.6,2.613,2.613,0,0,1,6.377,105.03Zm-.079-1.2a1.406,1.406,0,1,1,1.313-1.313A1.4,1.4,0,0,1,6.3,103.827Z" transform="translate(0 -98.725)" fill="#8392a5" />
                            </svg>
                          </span> */}
                          <div className='nf-btn nf-btn-default' onClick={() => copyEndpoint(wbURL)}>
                            <svg style={{ position: 'relative', top: '-1px' }} xmlns="http://www.w3.org/2000/svg" width="12" height="14" viewBox="0 0 9 10">
                              <path id="Path_59481" data-name="Path 59481" d="M6.429-12.25H3.054a1.111,1.111,0,0,1-1.125-1.094v-5.781H.482A.476.476,0,0,0,0-18.656v7.188A.476.476,0,0,0,.482-11H5.946a.476.476,0,0,0,.482-.469Zm0-6.719V-21H3.054a.476.476,0,0,0-.482.469v7.188a.476.476,0,0,0,.482.469H8.518A.476.476,0,0,0,9-13.344V-18.5H6.911A.477.477,0,0,1,6.429-18.969Zm2.43-.606L7.534-20.863A.488.488,0,0,0,7.193-21H7.071v1.875H9v-.118A.461.461,0,0,0,8.859-19.575Z" transform="translate(0 21)" fill="#fff" />
                            </svg>
                            &nbsp;
                            Copy URL
                          </div>
                          <span className="btn-action nf-btn light-bg-icon btn-icon-20  tbl-action-dlt"
                            onClick={() => openReviewModel(usInt)}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="12.414" height="7.4" viewBox="0 0 12.414 7.4">
                              <path id="Path_14253" data-name="Path 14253" d="M6.207,98.725A7.744,7.744,0,0,0,.1,102.13a.491.491,0,0,0,0,.587,7.74,7.74,0,0,0,6.11,3.408,7.744,7.744,0,0,0,6.11-3.405.491.491,0,0,0,0-.587A7.74,7.74,0,0,0,6.207,98.725Zm.17,6.305A2.611,2.611,0,1,1,8.812,102.6,2.613,2.613,0,0,1,6.377,105.03Zm-.079-1.2a1.406,1.406,0,1,1,1.313-1.313A1.4,1.4,0,0,1,6.3,103.827Z" transform="translate(0 -98.725)" fill="#8392a5" />
                            </svg>
                          </span>
                          <span className="btn-action nf-btn  btn-delete-light  light-bg-icon btn-icon-20  tbl-action-dlt"
                            onClick={() => deleteWebhook({ id: usInt._id, inm: usInt.inm })}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 176 192">
                              <g id="Group_8307" data-name="Group 8307" transform="translate(-8)">
                                <path id="Path_12759" data-name="Path 12759" d="M128,32V24A24.027,24.027,0,0,0,104,0H88A24.027,24.027,0,0,0,64,24v8H8V48H184V32ZM80,24a8.009,8.009,0,0,1,8-8h16a8.009,8.009,0,0,1,8,8v8H80Z" fill="#fb5360" />
                                <path id="Path_12760" data-name="Path 12760" d="M30.467,170.651A23.976,23.976,0,0,0,54.321,192h83.358a23.976,23.976,0,0,0,23.854-21.35L174.272,56H17.728Zm87.561-99.316,15.944,1.33-8,96-15.944-1.33Zm-44.056,0,8,96-15.944,1.33-8-96Z" fill="#fb5360" />
                              </g>
                            </svg>
                          </span>
                        </div>
                      </div>
                    </div>;
                  }) : <div className="card-editor card-intigra-block card-intigra-ggpalceislist" >
                    <div className="integra-checklist-item" >
                      <span> No record found</span>
                    </div>
                  </div>}
              </div>
            </div>
          </div>}
      </div>
    </div >
  );
};


export default Webhook;


// WEBPACK FOOTER //
// ./src/components/Integration/Webhook.js